import React from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'utils';
import logoSvg from './logo.svg';

export default function Logo({ className = undefined, logo = undefined, ...rest }) {
  if (!logo) {
    return (
      <img
        className={classNames(className, 'Logo')}
        width={50}
        height={48}
        src={logoSvg}
        alt="The Host Co"
        {...rest}
      />
    );
  }
  return (
    <img className={classNames(className, 'Logo')} width={50} height={50} src={logo} {...rest} />
  );
}

Logo.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};
